module.exports = __webpack_public_path__ + "img/companyIntro8.e3155513.png";